import { GoogleMapTypeStyle } from './google-map-api.interface';

export const mapStyleSimple: GoogleMapTypeStyle[] = [
    {
        elementType: 'geometry',
        stylers: [
            {
                color: 'F6F7F9',
            },
        ],
    },
    {
        elementType: 'geometry.stroke',
        stylers: [
            {
                visibility: 'on',
            },
        ],
    },
    {
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#c7cfd6',
            },
            {
                weight: 2,
            },
        ],
    },
    {
        featureType: 'administrative.locality',
        elementType: 'labels',
        stylers: [
            {
                color: '#636d79',
            },
            {
                visibility: 'simplified',
            },
        ],
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#c7cfd6',
            },
            {
                weight: 1.5,
            },
        ],
    },
    {
        featureType: 'administrative.province',
        elementType: 'labels',
        stylers: [
            {
                color: '#636d79',
            },
            {
                visibility: 'simplified',
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#c7cfd6',
            },
            {
                weight: 1,
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'simplified',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
];
